import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
const playContainerStyle = {
    position: 'absolute',
    top: '50%',
    left: '53%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'white',
    padding: '.75rem',
    borderRadius: 24,
    width: 100,
    height: 48,
    cursor: 'pointer',
    zIndex: '2',
    fontWeight: 700
};
export const PlayButton = ({ onPlayClick, id, text }) => (_jsxs(Box, { role: 'button', onClick: () => onPlayClick(), sx: playContainerStyle, id: id, children: [_jsx(PlayArrowIcon, { sx: { marginRight: '0.5rem' } }), _jsx(Typography, { sx: { fontWeight: 600 }, children: text })] }));
//# sourceMappingURL=PlayButton.js.map